/**
 * Canonical event session-id encoding, shared by frontend and backend so
 * availability/capacity/claims always agree.
 *
 * A session id is either:
 *   - a bare date (`"2026-07-04"`) for DATE-granularity events, or
 *   - `"<date>::<timeSlotId>"` for TIME_SLOT-granularity events.
 *
 * IMPORTANT: the time-slot component is the slot's stable `_id`, NOT its start
 * time. Encoding by start time breaks when a slot's time changes; encoding by id
 * keeps the session identity stable across edits.
 */

export const SESSION_ID_SEPARATOR = "::";

export const buildEventSessionId = (
  date: string,
  timeSlotId?: string | null,
): string =>
  timeSlotId ? `${date}${SESSION_ID_SEPARATOR}${timeSlotId}` : date;

export const parseSessionId = (
  sessionId: string,
): { date: string; timeSlotId?: string } => {
  const [date, timeSlotId] = sessionId.split(SESSION_ID_SEPARATOR);
  return timeSlotId ? { date, timeSlotId } : { date };
};
